import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { PURCHASE_ACTIONS } from 'assets/constants/purchaseActions';
import RedButton from 'components/buttons/RedButton';
import { ItemCheckoutState } from 'features/checkout/item/itemCheckoutState';

import { TrackedItemComponentsProps } from './trackedItemUtils';

export const PayNowButton = ({ isBuyer, order, onClick }: TrackedItemComponentsProps) => {
  const { t } = useTranslation('myProfile');
  const navigate = useNavigate();

  const status = order?.status;
  const itemId = order?.itemId;

  const canPayNow = () => {
    return isBuyer && status && PURCHASE_ACTIONS[status].canPayNow;
  };

  const handleOnClick = () => {
    onClick?.();
    const state: ItemCheckoutState = { auctionOrder: order };
    navigate(`/checkout/${itemId}`, { state });
  };

  if (!canPayNow()) return null;
  return (
    <RedButton data-testid={'pay-now-btn'} onClick={handleOnClick}>
      {t('tracked-item.pay-now')}
    </RedButton>
  );
};
